import NotificationGroupSelect from './NotificationGroupSelect.component';

export default NotificationGroupSelect;